import { render } from "./FullFrameModal.vue?vue&type=template&id=237a626c&scoped=true"
import script from "./FullFrameModal.vue?vue&type=script&lang=js"
export * from "./FullFrameModal.vue?vue&type=script&lang=js"

import "./FullFrameModal.vue?vue&type=style&index=0&id=237a626c&scoped=true&lang=css"

import exportComponent from "/Users/permartinson/Documents/GitHub/wpcedit/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-237a626c"]])

export default __exports__